import { useState, useEffect } from "react";
import { userAtom } from "../../atoms/userAtom";
import { useAtom } from "@dbeining/react-atom";
export const useEventCalendarState = (visable?: boolean) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showEventDetails, setShowEventDetails] = useState(false);
  const [showEventAdd, setShowEventAdd] = useState(false);
  const [showEventUpdate, setShowEventUpdate] = useState(false);
  const [showEventRemove, setShowEventRemove] = useState(false);
  const [eventAddStart, setEventAddStart] = useState<Date | undefined>(undefined);
  const [eventAddEnd, setEventAddEnd] = useState<Date | undefined>(undefined);
  const [eventAddIsAllDay, setEventAddIsAllDay] = useState<boolean | undefined>(undefined);
  const [eventToBeUpdated, setEventToBeUpdated] = useState<any>(undefined);
  
  const currentUser = useAtom(userAtom);

  useEffect(() => {
    if (visable) {
      // This will be handled by the calendar ref in the main component
    }
  }, [visable]);

  const handleEventClick = (info: any, calendarRef: any) => {
    setEventToBeUpdated({
      groupId: info.event.groupId,
      taskId: info.event.extendedProps.taskId,
      title: info.event.title,
      start: info.event.start,
      end: info.event.end,
      allDay: info.event.allDay,
      color: info.event.backgroundColor,
      description: info.event.extendedProps.description,
      appointmentTypeId: info.event.extendedProps.appointmentTypeId,
      identityId: info.event.extendedProps.identityId,
      identityName: info.event.extendedProps.identityName,
      associatedIds: info.event.extendedProps.associatedIds,
    });
    setShowEventDetails(true);
  };

  const handleDatePickerSubmit = (values: any, { setStatus, setSubmitting }: any, calendarRef: any) => {
    setStatus();
    setSubmitting(false);
    if (calendarRef.current) {
      calendarRef.current.getApi().gotoDate(values.date);
    }
    setShowDatePicker(false);
  };

  const handleSelect = (selectionInfo: any) => {
    setEventAddStart(selectionInfo.start);
    setEventAddEnd(selectionInfo.end);
    setEventAddIsAllDay(selectionInfo.allDay);
    setShowEventAdd(true);
  };

  const handleAddEventButton = () => {
    setEventAddStart(undefined);
    setEventAddEnd(undefined);
    setEventAddIsAllDay(undefined);
    setShowEventAdd(true);
  };

  const handleGoToDateButton = () => {
    setShowDatePicker(true);
  };

  return {
    showDatePicker,
    setShowDatePicker,
    showEventDetails,
    setShowEventDetails,
    showEventAdd,
    setShowEventAdd,
    showEventUpdate,
    setShowEventUpdate,
    showEventRemove,
    setShowEventRemove,
    eventAddStart,
    eventAddEnd,
    eventAddIsAllDay,
    eventToBeUpdated,
    setEventToBeUpdated,
    currentUser,
    handleEventClick,
    handleDatePickerSubmit,
    handleSelect,
    handleAddEventButton,
    handleGoToDateButton,
  };
};
